"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ContentBlocks;
const react_1 = __importDefault(require("react"));
const KevelAnalytics_1 = __importDefault(require("../KevelAnalytics/KevelAnalytics"));
const NewRelic_1 = __importDefault(require("../NewRelic/NewRelic"));
const ContentBlockCard_1 = __importDefault(require("../ContentBlockCard/ContentBlockCard"));
const ContentBlocks_module_scss_1 = __importDefault(require("./ContentBlocks.module.scss"));
function ContentBlocks({ data }) {
    if (data.length === 0) {
        return null;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { "data-testid": "content-blocks-container", className: ContentBlocks_module_scss_1.default.blockContainer }, data.map((block) => (react_1.default.createElement("div", { key: block.associatedAdvertId, "data-testid": `content-block-${block.slotNumber}`, className: ContentBlocks_module_scss_1.default.block },
            react_1.default.createElement(ContentBlockCard_1.default, Object.assign({}, block)),
            react_1.default.createElement(NewRelic_1.default, { adId: block.associatedAdvertId, esiType: "category" }))))),
        react_1.default.createElement(KevelAnalytics_1.default, { events: data.map((block) => ({
                adId: block.associatedAdvertId,
                type: "banner",
                clickUrl: block.clickUrl,
                impressionUrl: block.impressionUrl,
                esiType: block.esiType,
            })) })));
}
